import { useEffect, useRef } from 'react'

export const useTimeoutIf = (
  callback: () => void,
  delay: number | null,
  condition: () => boolean
) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    if (delay !== null && condition()) {
      const id = setTimeout(tick, delay)
      return () => clearTimeout(id)
    }
  }, [delay, condition])
}
